module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_PromoGuardian02.b058aac6.jpg";